export interface ITransportations {
  Flug: boolean
  Wunschflug: boolean
  Bahn: boolean
  Individuell: boolean
}

export type TransportationCategory = 'Flug' | 'Wunschflug' | 'Bahn' | 'Individuell'

export enum FlightClassEnum {
  B = 'B',
  C = 'C',
  F = 'F',
  P = 'P',
  Y = 'Y'
}
export type FlightClass = 'Y' | 'P' | 'C' | 'F' | 'B' 